import { render, staticRenderFns } from "./Referrer.vue?vue&type=template&id=29615185"
import script from "./Referrer.vue?vue&type=script&lang=js"
export * from "./Referrer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports